// @module NXTurn.ShoppingExtensions.NewArrivals
define('C3.ShoppingExtensions.PDP.CrossSellItems.View'
,	[
		'item_relations_cell.tpl',
		'item_relations_row.tpl',
        'facets_items_collection.tpl',
        'facets_items_collection_view_cell.tpl',
        'facets_items_collection_view_row.tpl',
		'c3_shoppingextensions_crosssell_items.tpl',
        'C3.ShoppingExtensions.PDP.CrossSellItems.CellView',
		'Tracker',
		'Utils',
		'C3.ShoppingExtensions.PDP.CrossSellItems.Collection',
		'Backbone.CollectionView',
		'Backbone'
    ]
, function (
	item_relations_cell_tpl,
	item_relations_row_tpl,
    facets_items_collection_tpl,
    facets_items_collection_view_cell_tpl,
    facets_items_collection_view_row_tpl,
	nxturn_shoppingextensions_crosssell_items_tpl,
   // facets_items_collection_view_cell_tpl,
   // facets_items_collection_view_row_tpl,
	//ItemRelationsRelatedItemView,
    NXTurnShoppingExtensionsPDPCrossSellItemsCellView,
	Tracker,
	Utils,
	NXTurnShoppingExtensionsPDPCrossSellItemsCollection,
	BackboneCollectionView,
	Backbone
)
{
    'use strict';

	// @class NXTurn.ShoppingExtensions.NewArrivals.View @extends Backbone.View
	return BackboneCollectionView.extend({

		initialize: function (options) {

           this.slideWidth = options.slideWidth;
           this.maxSlides = options.maxSlides;
            
		const { siteSettings } = this.options.application.getConfig();
        const is_sca_advanced = siteSettings.sitetype === 'ADVANCED';
        const collection = is_sca_advanced
            ? new NXTurnShoppingExtensionsPDPCrossSellItemsCollection({ itemsIds: this.options.itemsIds})
            : new Backbone.Collection();

        //console.log(this.options.itemsIds)
        

        var itemIdsLength = collection.itemsIds
         //console.log(itemIdsLength)   
        BackboneCollectionView.prototype.initialize.call(this, {
            collection: collection,
            viewsPerRow: Infinity,
            cellTemplate: item_relations_cell_tpl,
            rowTemplate: item_relations_row_tpl,
            childView: NXTurnShoppingExtensionsPDPCrossSellItemsCellView,
            template: nxturn_shoppingextensions_crosssell_items_tpl,
            childViewOptions: {
                    origin: 'Cross-Sell',
                    hideArrows : itemIdsLength.length <= 5 ? true : false,
                    application : this.options.application,
                    configuration : this.options.configuration,
                    container : this.options.container
                }
        });

        this.view_tracked = false;

        if (is_sca_advanced) {
            this.once('afterCompositeViewRender', this.loadRelatedItems, this);
        }
		},

		loadRelatedItems: function loadRelatedItems() {
        const self = this;

        self.collection.fetchItems().done(function() {
            if (self.collection.length) {
                if (!self.view_tracked) {
                    Tracker.getInstance().trackProductListEvent(
                        self.collection,
                        'More to consider Items'
                    );
                    self.view_tracked = true;
                }
            }

            self.render();

           // if(!Utils.isPhoneDevice())
           // {

            setTimeout(function() {
                const carousel = self.$el.find('[data-type="carousel-items"]');

                const {
                    siteSettings,
                    imageSizeMapping,
                    bxSliderDefaults
                } = self.options.application.getConfig();

                if (Utils.isPhoneDevice() === false && siteSettings.imagesizes) {
                    const img_min_height = (_.where(siteSettings.imagesizes, {
                        name: imageSizeMapping.thumbnail
                    })[0]).maxheight;

                    carousel
                        .find('.item-relations-related-item-thumbnail')
                        .css('minHeight', img_min_height);
                }
                
               // bxSliderDefaults.slideWidth = 253;

                if(self.collection.length >= 6)
                {
                  bxSliderDefaults.controls = true;  
                  bxSliderDefaults.slideWidth = 252;
                }
                else{
                   bxSliderDefaults.slideWidth = 262;
                   bxSliderDefaults.controls = false;  
                }
                
                bxSliderDefaults.maxSlides = 5;
                bxSliderDefaults.controls = true;
                bxSliderDefaults.hideControlOnEnd = true;
                bxSliderDefaults.prevText = '<a data-click="left-click" data-action="pdp-crosssellitems-click" class="pdp-crosssell carousel-items-prev-icon"><img class="left-icon-img" src="/SSP Applications/AAMedicalStore/AAMedicalStore/img/Left Arrow-Grey.svg"></a>';
                bxSliderDefaults.nextText = '<a data-click="right-click" data-action="pdp-crosssellitems-click" class="pdp-crosssell carousel-items-next-icon"><img class="right-icon-img" src="/SSP Applications/AAMedicalStore/AAMedicalStore/img/Right Arrow.svg"></a>';         
                /*bxSliderDefaults.prevText = '<a class="carousel-items-prev-icon"><img src="/SSP Applications/AAMedicalStore/AAMedicalStore/img/Left Arrow.svg"></a>';
                bxSliderDefaults.nextText = '<a class="carousel-items-next-icon"><img src="/SSP Applications/AAMedicalStore/AAMedicalStore/img/Right Arrow.svg"></a>';
                *///bxSliderDefaults.touchEnabled = false;
               //console.log(bxSliderDefaults)
                bxSliderDefaults.infiniteLoop = false;
                Utils.initBxSlider(carousel, bxSliderDefaults);
            });
           // }
        });
    }

	});
});
